import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { FaTimes } from 'react-icons/fa';

const ModalBackdrop = styled.div`
  position: fixed; top: 0; left: 0; right: 0; bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex; justify-content: center; align-items: center; z-index: 1050;
`;

const ModalContent = styled.div`
  background: white; padding: 2rem; border-radius: 8px;
  width: 90%; max-width: 600px; position: relative;
`;

const CloseButton = styled.button`
  position: absolute; top: 15px; right: 15px;
  background: none; border: none; font-size: 1.5rem; cursor: pointer;
`;

const Title = styled.h2`
  margin-top: 0; margin-bottom: 1.5rem;
`;

const StyledTextArea = styled.textarea`
  width: 100%;
  min-height: 250px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 1rem;
  line-height: 1.5;
  margin-bottom: 1rem;
`;

const SubmitButton = styled.button`
  padding: 10px 20px;
  background-color: #28a745;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: bold;
  &:disabled { background-color: #ccc; }
`;

const CompletionModal = ({ order, onSubmit, onClose }) => {
    const [notes, setNotes] = useState('');

    useEffect(() => {
        if (order) {
            const age = order.userDob ? new Date().getFullYear() - new Date(order.userDob).getFullYear() : 'N/A';
            const reason = order.orderDetails.items.map(i => i.name).join(', ');
            const template = `Age: ${age}\nReason for note: ${reason}\nRed flags: \n\nReviewed ${age}-year-old presenting via video with a history of...\nVideo confirms...\nEvidence uploaded supports presentation...\nAssessment: \nSafety netting provided.`;
            setNotes(template);
        }
    }, [order]);

    const handleSubmit = () => {
        if (notes.trim() === '') {
            alert('Clinical notes cannot be empty.');
            return;
        }
        onSubmit(order.orderDetails.orderId, notes);
    };

    if (!order) return null;

    return (
        <ModalBackdrop onClick={onClose}>
            <ModalContent onClick={e => e.stopPropagation()}>
                <CloseButton onClick={onClose}><FaTimes /></CloseButton>
                <Title>Complete Order & Add Clinical Notes</Title>
                <p>Please confirm your clinical assessment before completing the order.</p>
                <StyledTextArea
                    value={notes}
                    onChange={(e) => setNotes(e.target.value)}
                />
                <SubmitButton onClick={handleSubmit}>Confirm Completion</SubmitButton>
            </ModalContent>
        </ModalBackdrop>
    );
};

export default CompletionModal;